import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { formatDateLocale } from "../../infrastructure/utils/formatDateLocale";
import "./css/lightpick.css";
import "./css/jquery.timepicker";
import "./css/jquery.timepicker.css";
import "./css/searchbar.scss";
import "./css/easepick.css";
import "react-day-picker/style.css";
import "./search_bar/form/dateRangePicker.scss";
import "./../assets/saas/pages/search-bar.scss";
import SubmitSearch from "../../infrastructure/services/search_bar/submitSearch";
import handleLocationChangeSearchBar from "../../infrastructure/services/search_bar/handleLocationChange";
import InputTimePciker from "./search_bar/timePickerInputBox";
import TimePickerDeclarations from "./search_bar/timePickerDeclarations";
import TimePickerObserver from "./search_bar/timePickerObserver";
import OnLoadValidations from "../../infrastructure/services/search_bar/onLoadValidations";
import LocationInputsHandler from "./search_bar/locationsInputsHandler";
import SearchDetails from "./search_bar/form/searchDetails";
import SearchBarMain from "./search_bar/form/searchBarMain";
import LitePickerComponent from "./search_bar/form/litePickerComponent";
import ModalPopUpTarget from "./details/controls/ModalPopUpTarget";
import { container } from "tsyringe";
import TimePickerModal from "./search_bar/form/timePickerModal";
import { useTranslation } from "react-i18next";
import Checkbox from "./commons/checkbox";
import { ObjectId } from "bson";
// Styles
import "../assets/saas/organisms/_searchbar.scss";
import { TYPE_TAG } from "./search_bar/form/tags/interface/typeTag";
import { usePage } from "presentation/hooks/usePage";
const SearchBar = () => {
    // Resolver DI
    const dataStore = container.resolve("IUseStoreAplication");
    // --------------
    moment.locale(sessionStorage.getItem("locale") || "es");
    const { t, i18n } = useTranslation();
    // WI #8606: single locale source — t("locale") from i18next, same source
    // used by Litepicker (lang) and react-day-picker (localeMap).
    const formatDateDisplay = (date) => formatDateLocale(date, t("locale") || "en");
    const currentDate = moment();
    const [checked, setChecked] = useState(false);
    const [locations, setLocations] = useState([""]);
    const roundedTime = moment()
        .startOf("hour")
        .add(moment().minute() >= 30 ? 1 : 0, "hour");
    const [startTime, setStartTime] = useState(["12:00 pm", "12:00"]);
    const [endTime, setEndTime] = useState(["12:00 pm", "12:00"]);
    const [endNewTime, setEndNewTime] = useState(["12:00 pm", "12:00"]);
    const [pickOption, setPickOption] = useState("pick_option_24");
    const [dropOption, setDropOption] = useState("drop_option_24");
    const [selectedPickupLocation, setSelectedPickupLocation] = useState(["", "", 0]);
    const [selectedReturnLocation, setSelectedReturnLocation] = useState(["", "", 0]);
    const [filters, setFilters] = useState({
        renterFilters: [],
        categoryFilters: [],
        rateFilters: [],
        engineFilters: [],
    });
    const [pickupLocationError, setPickupLocationError] = useState(false);
    const [returnLocationError, setReturnLocationError] = useState(false);
    const [showBack, setShowBack] = useState(false);
    const validateDateLocation = container.resolve("iValidateDateLocation");
    const generateSessionId = container.resolve("IGenerateSessionId");
    const urlParams = new URLSearchParams(window.location.search);
    const normalizeCountry = (country) => country ? country.toString().trim().toUpperCase() : undefined;
    const [userCountry, setUserCountry] = useState(normalizeCountry(sessionStorage.getItem("country")) || "US");
    let startDate_ = sessionStorage.getItem("startDate_")
        ? sessionStorage.getItem("startDate_")
        : urlParams.get("pickUpDate")
            ? urlParams.get("pickUpDate")
            : moment().format("YYYY-MM-DD");
    let endDate_ = sessionStorage.getItem("endDate_")
        ? sessionStorage.getItem("endDate_")
        : urlParams.get("returnDate")
            ? urlParams.get("returnDate")
            : moment().add(7, "days").format("YYYY-MM-DD");
    startDate_ = validateDateLocation.validateDateGreaterThanToday(startDate_, 1);
    endDate_ = validateDateLocation.validateDateGreaterThanToday(endDate_, 7);
    const [startDate, setStartDate] = useState([
        formatDateDisplay(startDate_),
        "" + moment(startDate_).format("YYYY-MM-DD"),
    ]);
    const [endDate, setEndDate] = useState([
        formatDateDisplay(endDate_),
        "" + moment(endDate_).format("YYYY-MM-DD"),
    ]);
    let reservationTime = moment().add(1, "h");
    let reservationTimeList = [reservationTime.format("hh:00 a"), reservationTime.format("HH:00")];
    function formatDateToDdMmYyyy(inputDate) {
        return moment(inputDate).format("YYYY-MM-DD").toString();
    }
    const payload = useMemo(() => {
        var _a, _b, _c, _d, _e, _f;
        return ({
            userId: "1",
            pickUpDateTime: `${formatDateToDdMmYyyy((_a = startDate[1]) === null || _a === void 0 ? void 0 : _a.toString())}T${startTime[1]}:00`,
            returnDateTime: `${formatDateToDdMmYyyy((_b = endDate[1]) === null || _b === void 0 ? void 0 : _b.toString())}T${endTime[1]}:00`,
            userCountry: sessionStorage.getItem("country") || "US",
            device: navigator.userAgent,
            pickUpLocation: {
                locationCode: ((_c = selectedPickupLocation[1]) === null || _c === void 0 ? void 0 : _c.toString()) || null,
                codeContext: "IATA",
                locationName: selectedPickupLocation[0],
            },
            returnLocation: {
                locationCode: selectedReturnLocation[1] != ""
                    ? (_d = selectedReturnLocation[1]) === null || _d === void 0 ? void 0 : _d.toString()
                    : ((_e = selectedPickupLocation[1]) === null || _e === void 0 ? void 0 : _e.toString()) || null,
                codeContext: "IATA",
                locationName: selectedReturnLocation[0] != "" ? selectedReturnLocation[0] : selectedPickupLocation[0],
            },
            brand: "",
            searchId: new ObjectId().toHexString(),
            language: i18n.language.toUpperCase(),
            market: sessionStorage.getItem("market") || "us",
            paging: {
                pageNumber: 1,
                pageSize: Number((_f = process.env.REACT_APP_PAGINATE_RESULTS) !== null && _f !== void 0 ? _f : 5),
            },
            filter: {
                renters: filters.renterFilters,
                typesCar: filters.categoryFilters,
                fuelTypes: filters.engineFilters,
                groupRates: filters.rateFilters,
            },
            idSession: sessionStorage.getItem("guid") || "",
            visitorId: sessionStorage.getItem("userFP") || "",
            sort: {
                name: "",
                order: "",
            },
        });
    }, [startDate, startTime, endDate, endTime, selectedPickupLocation, selectedReturnLocation, i18n.language, filters]);
    const getData = async () => {
        //check if the url has a path called collections
        if (!window.location.pathname.includes("/collections")) {
            //change the idSession to a new one
            payload.idSession = generateSessionId.handle();
            sessionStorage.setItem("guid", payload.idSession);
            sessionStorage.setItem("preloadSearchStarted", "true");
            sessionStorage.setItem("shouldFilter", "true");
            //empty the session storage value called idSession
            sessionStorage.removeItem("idSession");
            sessionStorage.removeItem("filters");
            sessionStorage.setItem("searchId", payload.searchId);
            /*_BookingServices.getAvailability(payload, null, (offersData: any) => {
              sessionStorage.setItem("searchId", offersData.searchId);
            }, false,
              sessionStorage.getItem("userFP") || "");*/
        }
    };
    const pathname = window.location.pathname;
    const [footerHtml, setFooterHtml] = useState(`
    <span class="js-start-date start-date">${formatDateDisplay(startDate[1])}</span>
    <span> - </span>
    <span class="js-end-date end-date" id="endDateBar">${formatDateDisplay(endDate[1])}</span>
`);
    const [showDateModal, setShowDateModal] = useState(false);
    const [datePicker, setDatePicker] = useState();
    const [showTimeModal, setShowTimeModal] = useState(false);
    const [trigger, setTrigger] = useState(0);
    const [formData, setFormData] = useState({
        pickupLocationCode: "",
        returnLocationCode: "",
        pickupDate: "",
        returnDate: "",
        pickupTime: "12:00",
        returnTime: "12:00",
        totalDays: 0,
        countryDestination: "US",
        vehhicleType: "Economy ",
    });
    const handleSubmit = (event) => {
        if (startTime[0] == null) {
            setStartTime(["12:00 pm", "12:00 pm"]);
        }
        if (endTime[0] == null) {
            setEndTime(["12:00 pm", "12:00 pm"]);
        }
        if (isValidSubmit()) {
            var searchUrl = SubmitSearch({
                selectedPickupLocation,
                selectedReturnLocation,
                startDate,
                endDate,
                startTime,
                endTime,
                checked,
                formData,
                currentDate,
            });
            if (urlParams.has("app")) {
                searchUrl += `&app`;
            }
            if (searchUrl !== undefined) {
                searchUrl = Evaluatelanding(searchUrl);
                window.location.href = searchUrl;
                sessionStorage.removeItem("filters");
            }
            else {
                console.error("La URL de búsqueda es undefined.");
            }
        }
    };
    const formatDate = (date) => {
        return formatDateDisplay(date);
    };
    const isValidSubmit = () => {
        if (selectedPickupLocation[1] == "") {
            setPickupLocationError(true);
        }
        if (checked && selectedReturnLocation[1] == "") {
            setReturnLocationError(true);
            return false;
        }
        if (selectedPickupLocation[1] == "" || startDate[1] == moment(currentDate).format("ddd DD MMM")) {
            return false;
        }
        return true;
    };
    const Evaluatelanding = (url) => {
        var _a;
        var landingid = (_a = document.getElementById("landingId")) === null || _a === void 0 ? void 0 : _a.value;
        if (landingid != null) {
            if (landingid.length > 0) {
                url = url + "&landingId=" + landingid;
            }
        }
        return url;
    };
    document.addEventListener("click", function (event) {
        let target = event.target;
        while (target) {
            if (target.matches(".close_date_picker")) {
                break;
            }
            target = target.parentElement;
        }
    });
    const handleLocationChange = (e, setNoResults, countryOverride) => {
        const effectiveCountry = countryOverride || userCountry;
        handleLocationChangeSearchBar({
            e,
            setLocations,
            setSelectedPickupLocation,
            setSelectedReturnLocation,
            setNoResults,
            userCountry: effectiveCountry,
            checked
        });
    };
    let timePickerInputBox = InputTimePciker({ startTime, t });
    function removeTimePickerInputBox() {
        const timePickerInputWrapper = document.querySelector(".timepicker-input--wrapper");
        if (timePickerInputWrapper) {
            timePickerInputWrapper.remove();
        }
    }
    TimePickerDeclarations({
        endTime,
        setEndTime,
        removeTimePickerInputBox,
        startTime,
        setStartTime,
        startDate,
        endDate,
        roundedTime,
        getData,
    });
    TimePickerObserver(timePickerInputBox);
    // store
    const { setRecommendedLocations, setActiveTag } = dataStore.actions;
    const { recommendedLocations = [], activeTag } = dataStore.app;
    const { isHomePage } = usePage();
    useEffect(() => {
        //if loaded from the main page (home, /), set the session storage item "searchId" to ""
        if (isHomePage) {
            sessionStorage.setItem("searchId", "");
        }
        if (startTime[0] == null) {
            setStartTime(["12:00 pm", "12:00"]);
        }
        if (endTime[0] == null) {
            setEndTime(["12:00 pm", "12:00"]);
        }
        // check the presence of the values in the session storage
        OnLoadValidations({
            setLocations,
            setSelectedPickupLocation,
            setSelectedReturnLocation,
            setStartDate,
            setEndDate,
            setStartTime,
            setEndTime,
            setChecked,
            startDate,
            endDate,
            startTime,
            endTime,
            selectedPickupLocation,
            selectedReturnLocation,
            setRecommendedLocations,
            userCountry,
        });
        LocationInputsHandler({
            setSelectedReturnLocation,
            setShowBack,
            onHandleTagShowKey,
        });
        //when the witdh of the body changes from less than 1000 to greater than 1000, render gaina the date picker
        LitePickerComponent({
            setEndDate,
            setStartDate,
            setShowDateModal,
            startDate,
            endDate,
            footerHtml,
            setFooterHtml,
            formatDate,
            t,
            getData,
            setTrigger,
        });
        const handleResize = () => {
            if (window.innerWidth < 1000) {
            }
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    useEffect(() => {
        if (trigger != 0) {
            getData();
        }
    }, [trigger]);
    useEffect(() => {
        if (checked) {
            setSelectedReturnLocation((currentReturnLocation) => {
                var _a, _b, _c, _d;
                const returnName = Array.isArray(currentReturnLocation)
                    ? String((_a = currentReturnLocation[0]) !== null && _a !== void 0 ? _a : "").trim()
                    : "";
                const returnCode = Array.isArray(currentReturnLocation)
                    ? String((_b = currentReturnLocation[1]) !== null && _b !== void 0 ? _b : "").trim()
                    : "";
                const pickupName = String((_c = selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[0]) !== null && _c !== void 0 ? _c : "").trim();
                const pickupCode = String((_d = selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[1]) !== null && _d !== void 0 ? _d : "").trim();
                if (returnName !== "" && returnCode !== "") {
                    return currentReturnLocation;
                }
                if (returnCode !== "" && pickupCode !== "" && returnCode !== pickupCode) {
                    return currentReturnLocation;
                }
                return [
                    returnName || pickupName,
                    returnCode || pickupCode,
                    (currentReturnLocation === null || currentReturnLocation === void 0 ? void 0 : currentReturnLocation[2]) || (selectedPickupLocation === null || selectedPickupLocation === void 0 ? void 0 : selectedPickupLocation[2]) || 0,
                ];
            });
        }
    }, [checked, selectedPickupLocation]);
    useEffect(() => {
        LocationInputsHandler({
            setSelectedReturnLocation,
            setShowBack,
            onHandleTagShowKey,
        });
    }, [locations]);
    useEffect(() => {
        setFooterHtml(`
              <span class="js-start-date start-date">${formatDate(startDate[1])}</span>
              <span> - </span>
              <span class="js-end-date end-date" id="endDateBar">${formatDate(endDate[1])}</span>
          `);
    }, [startDate, endDate]);
    const [showMenu, setShowMenu] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const [selectedCurrency, setSelectedCurrency] = useState("");
    const handleButtonClick = (event) => {
        event.preventDefault();
        if (window.innerWidth < 768) {
            setPosition({ top: 0, left: 0 });
        }
        else {
            //get the witdh of the body and get the 80% of it
            const bodyWidth = document.body.clientWidth;
            const left = bodyWidth - 418;
            setPosition({ top: 64, left: left });
        }
        setShowMenu(true);
    };
    useEffect(() => {
        const parent = document.querySelector(".desktop-localization-wrapper");
        parent === null || parent === void 0 ? void 0 : parent.addEventListener("click", handleButtonClick);
    }, []);
    const handleSelectLocation = () => {
        const form = document.getElementById("HeaderCountryForm");
        if (form) {
            const country_code = document.getElementById("country_code");
            country_code.value = selectedCurrency;
            form.submit();
        }
        setShowMenu(false);
    };
    useEffect(() => {
        if (selectedCurrency !== undefined && selectedCurrency !== "") {
            handleSelectLocation();
        }
    }, [selectedCurrency]);
    useEffect(() => {
        const startElement = document.getElementById("start");
        const endElement = document.getElementById("end");
        if (startElement) {
            startElement.value = formatDate(startDate[1]);
            endElement.value = formatDate(endDate[1]);
        }
    });
    /**
      * Function to handle the tag show key
      * This function is used to set the tagShowKey state variable
      * based on the key passed as an argument.
      * If the key is "driverLicenseInfo", it will not change the state.
      * @param key string - The key to set the tagShowKey state variable.
      * @returns void
      */
    const onHandleTagShowKey = (key) => {
        if (activeTag === TYPE_TAG.DRIVER_LICENSE_INFO)
            return;
        setActiveTag(key);
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: `searchbar-container scroll-trigger ${recommendedLocations.length > 0 ? "remove-space" : ""}`, children: [_jsx(SearchDetails, { selectedPickupLocation: selectedPickupLocation, selectedReturnLocation: selectedReturnLocation, setSelectedReturnLocation: setSelectedReturnLocation, startDate: startDate, endDate: endDate, startTime: startTime, endTime: endTime, t: t }), _jsx(SearchBarMain, { setPickupLocationError: setPickupLocationError, setReturnLocationError: setReturnLocationError, pickupLocationError: pickupLocationError, returnLocationError: returnLocationError, selectedPickupLocation: selectedPickupLocation, startDate: startDate, endDate: endDate, startTime: startTime, endTime: endTime, setSelectedPickupLocation: setSelectedPickupLocation, setSelectedReturnLocation: setSelectedReturnLocation, handleLocationChange: handleLocationChange, locations: locations, setLocations: setLocations, selectedReturnLocation: selectedReturnLocation, setChecked: setChecked, checked: checked, handleSubmit: handleSubmit, setShowBack: setShowBack, setShowTimeModal: setShowTimeModal, getData: getData, t: t, userCountry: userCountry }), _jsx("div", { className: "searchbar__back searchbar__back--desktop", children: _jsx(Checkbox, { id: "styled-checkbox-1", label: t("return_another_location"), value: "value1", checked: checked, onChange: () => {
                                setChecked(!checked);
                            } }) })] }), _jsx(ModalPopUpTarget, { children: datePicker, id: showDateModal ? "date-picker-modal" : "date-picker-modal-hide", setModalShow: setShowDateModal }), _jsx(ModalPopUpTarget, { id: showTimeModal ? "time-picker-modal" : "time-picker-modal-hide", setModalShow: setShowTimeModal, pickOption: pickOption, dropOption: dropOption, children: _jsx(TimePickerModal, { startTime: startTime, endTime: endTime, endNewTime: endNewTime, setShowTimeModal: setShowTimeModal, startDate: startDate, endDate: endDate, setStartTime: setStartTime, setEndTime: setEndTime, setEndNewTime: setEndNewTime, setPickOption: setPickOption, setDropOption: setDropOption, showTimeModal: showTimeModal, getData: getData, t: t }) }), showBack ? "" : ""] }));
};
export default SearchBar;
